import React, { useContext } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { Button, styled } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { AuthContext } from 'src/contexts/FirebaseAuthContext';

const StyledButton = styled(Button)(({ theme, isOpen }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: isOpen ? 'flex-start' : 'center',
  width: '100%',
  backgroundColor: 'transparent',
  color: theme.colors.alpha.trueWhite[70],
  padding: theme.spacing(1.2, 3),
  gap: theme.spacing(1),
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.colors.alpha.trueWhite[10],
    color: theme.colors.alpha.trueWhite[100],
  },
  '& .MuiSvgIcon-root': {
    fontSize: theme.typography.pxToRem(20),
    color: theme.colors.alpha.trueWhite[30],
  },
  '&:hover .MuiSvgIcon-root': {
    color: theme.colors.alpha.trueWhite[100],
  }
}));

const SupportButton = ({ isOpen = true }) => {
  const { user } = useContext(AuthContext);

  const handleSupportClick = async () => {
    try {
      if (user) {
        // Authenticated user - get user hash for secure identification
        // const hashResponse = await fetch('/api/integrations/intercom');
        // const hashData = await hashResponse.json();

        // Determine agent name and ID based on agent type
        let agentName = '';
        let agentId = '';
        let agentEmail = '';

        if (user.id_agente) {
          agentName = user.nombre_agente || 'Agente';
          agentId = user.id_agente;
          agentEmail = user.email_agente;
        } else if (user.id_subconcesionario) {
          agentName = user.nombre_subconcesionario || 'SubConcesionario';
          agentId = user.id_subconcesionario;
          agentEmail = user.email_subconcesionario;
        } else if (user.id_concesionario) {
          agentName = user.nombre_concesionario || 'Concesionario';
          agentId = user.id_concesionario;
          agentEmail = user.email_concesionario;
        }

        Intercom({
          app_id: 'l2erqbk4', // You'll need to replace this with your actual Intercom app ID
          user_id: agentId.toString(),
          name: agentName,
          company: 'POS',
          created_at: user.createdAt ? Math.floor(new Date(user.createdAt).getTime() / 1000) : undefined,
          // user_hash: hashData.hash,
          hide_default_launcher: true,
        });
      } else {
        // Unauthenticated user
        Intercom({
          app_id: 'l2erqbk4', // You'll need to replace this with your actual Intercom app ID
          company: 'POS',
          hide_default_launcher: true,
        });
      }

      if (typeof window !== 'undefined' && window.Intercom) {
        window.Intercom('show'); // Opens the Intercom Messenger
      }
    } catch (error) {
      console.error('Error initializing Intercom:', error);
      // Fallback - initialize without hash if API fails
      Intercom({
        app_id: 'l2erqbk4',
        company: 'POS',
        hide_default_launcher: true,
      });
      if (typeof window !== 'undefined' && window.Intercom) {
        window.Intercom('show');
      }
    }
  };

  return (
    <StyledButton
      type="button"
      onClick={handleSupportClick}
      isOpen={isOpen}
      fullWidth
    >
      <ChatBubbleOutlineIcon />
      {isOpen && <span>Soporte</span>}
    </StyledButton>
  );
};

export default SupportButton;
